const o = (n) => n.match(/^https?:\/\/.*/) ? n : `https://${n}`, a = (n, r) => `${o(n)}/${r}`, c = (n) => typeof n == "string" ? n.includes("x") ? n : `${n}x${n}` : typeof n == "number" ? `${n}x${n}` : `${n.at(0)}x${n.at(-1)}`, i = (n) => typeof n == "string" ? n : n.join(",");
function u(n, r, t, $, l) {
  const e = o(n);
  return t === "o" ? `${e}/media/${t}/${r}` : t === "rcf" ? `${e}/media/${t}/${c($)}/${l}/${r}` : t === "fill" ? `${e}/media/${t}/${c($)}/${i(l)}/${r}` : `${e}/media/${t}/${c($)}/${r}`;
}
export {
  a as createCdnFileUrl,
  u as createCdnMediaUrl
};
